import Sketch from '@arcgis/core/widgets/Sketch';
import MapView from '@arcgis/core/views/MapView';
import { MapPlacement } from '../shared/map/arcgis-types';
import { setupListeners } from './event-handler';
import { OnGeometryChangeHandler } from '.';
import Providers, { SKETCH_LAYER_ID, Providable, STATIC_LAYER_ID } from './providers';
import { GeometricType } from '../types/geo';

const init = (
  mapView: MapView,
  onGeometryChange: OnGeometryChangeHandler,
  fetchCurrentColor: () => string,
  geometryTypes: GeometricType[],
  providers?: Providable,
) => {
  const existingSketch = mapView.ui.find('sketch') as Sketch;
  if (existingSketch) { existingSketch.destroy(); }

  const existingSketchLayer = mapView.map?.findLayerById(SKETCH_LAYER_ID);
  if (existingSketchLayer) { existingSketchLayer.destroy(); }

  const existingStaticLayer = mapView.map?.findLayerById(STATIC_LAYER_ID);
  if (existingStaticLayer) { existingStaticLayer.destroy(); }

  const providable = providers ?? Providers(mapView);
  const sketch = providable.sketch();
  setupListeners(sketch, onGeometryChange, mapView, fetchCurrentColor);

  mapView.ui.add(sketch, MapPlacement.TopRight);

  return sketch;
};

export default init;
